import { Trans, useTranslation } from 'react-i18next';
import HomeNav from '../HomeNav';
import Background from '../Components/Background';
import Footer from '../Components/Footer/Footer';

const shouldUnescape = true;
const tOptions = Object.freeze({
  returnObjects: true,
  joinArrays: '',
});

/* eslint-disable react/prop-types */
function Paragraph(props) {
  const { tn } = props;
  return (
    <Trans
      i18nKey={`terms-and-condition-page.policy.${tn}`}
      {...{ shouldUnescape, tOptions }}
    />
  );
}

export default function TermsAndConditions() {
  const { t } = useTranslation();
  return (
    <div className="xpektor-home">
      <div className="policy-intro">
        <HomeNav />
        <div className="intro-section">
          <p className="section-title">
            {t('terms-and-condition-page.section-title')}
          </p>
          <h1>{t('terms-and-condition-page.title')}</h1>
          <p className="section-text">
            {t('terms-and-condition-page.last-updated')}:&nbsp;
            {t('terms-and-condition-page.date-version')}
          </p>
        </div>
      </div>
      <Background color1="white">
        <div className="policy-wrapper">
          <div className="policy-header">
            <p className="policy-title">
              {t('terms-and-condition-page.title')}
            </p>
            <p>
              {t('terms-and-condition-page.last-updated')}:&nbsp;
              {t('terms-and-condition-page.date')}
            </p>
          </div>
          <div className="toc-section">
            <a href="#terms-1">1. {t('terms-and-condition-page.toc.0')}</a>
            <a href="#terms-2">2. {t('terms-and-condition-page.toc.1')}</a>
            <a href="#terms-3">3. {t('terms-and-condition-page.toc.2')}</a>
            <a href="#terms-4">4. {t('terms-and-condition-page.toc.3')}</a>
            <a href="#terms-5">5. {t('terms-and-condition-page.toc.4')}</a>
            <a href="#terms-6">6. {t('terms-and-condition-page.toc.5')}</a>
            <a href="#terms-7">7. {t('terms-and-condition-page.toc.6')}</a>
            <a href="#terms-8">8. {t('terms-and-condition-page.toc.7')}</a>
            <a href="#terms-9">9. {t('terms-and-condition-page.toc.8')}</a>
            <a href="#terms-10">10. {t('terms-and-condition-page.toc.9')}</a>
            <a href="#terms-11">11. {t('terms-and-condition-page.toc.10')}</a>
            <a href="#terms-12">12. {t('terms-and-condition-page.toc.11')}</a>
            <a href="#terms-13">13. {t('terms-and-condition-page.toc.12')}</a>
            <a href="#terms-14">14. {t('terms-and-condition-page.toc.13')}</a>
            <a href="#terms-15">15. {t('terms-and-condition-page.toc.14')}</a>
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-1">
              1. {t('terms-and-condition-page.toc.0')}
            </p>
            <Paragraph tn="t00.0" />
            <Paragraph tn="t00.1" />
            <Paragraph tn="t00.2" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-2">
              2. {t('terms-and-condition-page.toc.1')}
            </p>
            <Paragraph tn="t01.0" />
            <Paragraph tn="t01.1" />
            <Paragraph tn="t01.2" />
            <Paragraph tn="t01.3" />
            <Paragraph tn="t01.4" />
            <Paragraph tn="t01.5" />
            <Paragraph tn="t01.6" />
            <Paragraph tn="t01.7" />
            <Paragraph tn="t01.8" />
            <Paragraph tn="t01.9" />
            <Paragraph tn="t01.10" />
            <Paragraph tn="t01.11" />
            <Paragraph tn="t01.12" />
            <Paragraph tn="t01.13" />
            <Paragraph tn="t01.14" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-3">
              3. {t('terms-and-condition-page.toc.2')}
            </p>
            <Paragraph tn="t02.0" />
            <Paragraph tn="t02.1" />
            <Paragraph tn="t02.2" />
            <Paragraph tn="t02.3" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-4">
              4. {t('terms-and-condition-page.toc.3')}
            </p>
            <Paragraph tn="t03.0" />
            <Paragraph tn="t03.1" />
            <Paragraph tn="t03.2" />
            <Paragraph tn="t03.3" />
            <Paragraph tn="t03.4" />
            <Paragraph tn="t03.5" />
            <Paragraph tn="t03.6" />
            <Paragraph tn="t03.7" />
            <Paragraph tn="t03.8" />
            <Paragraph tn="t03.9" />
            <Paragraph tn="t03.10" />
            <Paragraph tn="t03.11" />
            <Paragraph tn="t03.12" />
            <Paragraph tn="t03.13" />
            <Paragraph tn="t03.14" />
            <Paragraph tn="t03.15" />
            <Paragraph tn="t03.16" />
            <Paragraph tn="t03.17" />
            <Paragraph tn="t03.18" />
            <Paragraph tn="t03.19" />
            <Paragraph tn="t03.20" />
            <Paragraph tn="t03.21" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-5">
              5. {t('terms-and-condition-page.toc.4')}
            </p>
            <Paragraph tn="t04.0" />
            <Paragraph tn="t04.1" />
            <Paragraph tn="t04.2" />
            <Paragraph tn="t04.3" />
            <Paragraph tn="t04.4" />
            <Paragraph tn="t04.5" />
            <Paragraph tn="t04.6" />
            <Paragraph tn="t04.7" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-6">
              6. {t('terms-and-condition-page.toc.5')}
            </p>
            <Paragraph tn="t05.0" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-7">
              7. {t('terms-and-condition-page.toc.6')}
            </p>
            <Paragraph tn="t06.0" />
            <Paragraph tn="t06.1" />
            <Paragraph tn="t06.2" />
            <Paragraph tn="t06.3" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-8">
              8. {t('terms-and-condition-page.toc.7')}
            </p>
            <Paragraph tn="t07.0" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-9">
              9. {t('terms-and-condition-page.toc.8')}
            </p>
            <Paragraph tn="t08.0" />
            <Paragraph tn="t08.1" />
            <Paragraph tn="t08.2" />
            <Paragraph tn="t08.3" />
            <Paragraph tn="t08.4" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-10">
              10. {t('terms-and-condition-page.toc.9')}
            </p>
            <Paragraph tn="t09.0" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-11">
              11. {t('terms-and-condition-page.toc.10')}
            </p>
            <Paragraph tn="t10.0" />
            <Paragraph tn="t10.1" />
            <Paragraph tn="t10.2" />
            <Paragraph tn="t10.3" />
            <Paragraph tn="t10.4" />
            <Paragraph tn="t10.5" />
            <Paragraph tn="t10.6" />
            <Paragraph tn="t10.7" />
            <Paragraph tn="t10.8" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-12">
              12. {t('terms-and-condition-page.toc.11')}
            </p>
            <Paragraph tn="t11.0" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-13">
              13. {t('terms-and-condition-page.toc.12')}
            </p>
            <Paragraph tn="t12.0" />
            <Paragraph tn="t12.1" />
            <Paragraph tn="t12.2" />
            <Paragraph tn="t12.3" />
            <Paragraph tn="t12.4" />
            <Paragraph tn="t12.5" />
            <Paragraph tn="t12.6" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-14">
              14. {t('terms-and-condition-page.toc.13')}
            </p>
            <Paragraph tn="t13.0" />
            <Paragraph tn="t13.1" />
            <Paragraph tn="t13.2" />
            <Paragraph tn="t13.3" />
            <Paragraph tn="t13.4" />
            <Paragraph tn="t13.5" />
            <Paragraph tn="t13.6" />
            <Paragraph tn="t13.7" />
            <Paragraph tn="t13.8" />
            <Paragraph tn="t13.9" />
            <Paragraph tn="t13.10" />
            <Paragraph tn="t13.11" />
          </div>
          <div className="policy-section">
            <p className="section-title" id="terms-15">
              15. {t('terms-and-condition-page.toc.14')}
            </p>
            <Paragraph tn="t14.0" />
            <Paragraph tn="t14.1" />
            <Paragraph tn="t14.2" />
            <Paragraph tn="t14.3" />
            <Paragraph tn="t14.4" />
            <Paragraph tn="t14.5" />
          </div>
        </div>
        <Footer />
      </Background>
    </div>
  );
}
